document.addEventListener('DOMContentLoaded', function() {
    const megaNavs = document.querySelectorAll('.main-nav > li > details');
  
    megaNavs.forEach(megaNav => {
      const navMenus = megaNav.querySelectorAll('.main-nav__child.mega-nav.mega-nav--sidebar.has-motion > .container > ul.child-nav > li > .js-mega-nav');
      const disclosurePanels = megaNav.querySelectorAll('.main-nav__child.mega-nav.mega-nav--sidebar.has-motion > .container > .main-nav__item--has-children > .disclosure__panel');
  
      if (navMenus.length === 0 || disclosurePanels.length === 0) {
        return;
      }
  
      function showPanel(index) {
        disclosurePanels.forEach(panel => panel.style.display = 'none');
        disclosurePanels[index].style.display = 'block';
      }
  
      navMenus.forEach((navMenu, index) => {
        navMenu.addEventListener('mouseenter', function() {
          showPanel(index);
        });
      });
  
      showPanel(0);
    });
});
  